import React, { useEffect, useState, createRef } from 'react'
import { useDispatch } from 'react-redux'
import { getSimpeIframeGame } from 'integrationActions.js'
import * as styled from 'StyledLuckySix'

const PROVIDER = 'nsoft'
const SCRIPT_ID = 'iFrameResizeScript'

const Iframe = ({
  iframeUrl,
  iframeOnLoad
}) => {
  if (!iframeUrl) return null

  return (
    <styled.Iframe
      src={iframeUrl}
      onLoad={iframeOnLoad}
      title='LuckySix'
      id='seven-plugin'
      frameBorder={0}
      scrolling='no'
    />
  )
}

const LuckySix = () => {
  const dispatch = useDispatch()
  const [iframeUrl, setIframeUrl] = useState(undefined)
  const [scriptTag] = useState(document.createElement('script'))
  const instance = createRef(null)

  const iframeOnLoad = () => {
    scriptTag.onload = scriptOnLoad
    scriptTag.src = `${process.env.NSOFT_IFRAME_RESIZER}`
    scriptTag.id = SCRIPT_ID

    const scriptElement = !!instance.current && !!instance.current.querySelector(`#${SCRIPT_ID}`)

    !!instance.current && !scriptElement && instance.current.appendChild(scriptTag)
  }

  const scriptOnLoad = () => {
    !!iframeUrl && !!window.iFrameResize && window.iFrameResize({ checkOrigin: false })
  }

  // Get & set iframe src
  useEffect(() => {
    const getIframeUrl = async () => {
      const iframeUrl = await dispatch(getSimpeIframeGame(PROVIDER))

      setIframeUrl(iframeUrl)
    }

    getIframeUrl()
  }, [dispatch])

  return (
    <>
      <Iframe iframeUrl={iframeUrl} iframeOnLoad={iframeOnLoad} />
      <div ref={instance} />
    </>
  )
}

export default LuckySix
